<template>
  <div class="layout">
      <div class="header">
          <ol class="wrapp">
            <li @click="$router.push({ path:'/' })">Home</li>
            <li>&nbsp;&nbsp;>&nbsp;&nbsp;{{news.apkpkg}}</li>
          </ol>
      </div>
      <div class="main wrapp">
          <van-image
          radius="16"
          lazy-load
          :src="news.apkicon"
          />
          <h2 class="gamename">{{news.apkname}}</h2>
          <span v-if="news.developerName" class="developer">{{news.developerName}}&nbsp;&nbsp;</span> <span class="line" v-if="news.disversion && news.developerName">|</span> <span v-if="news.disversion" class="developer">&nbsp;&nbsp;{{news.disversion}}</span>
          <div class="star">
            <div class="star-container">
                <van-rate
                v-model="star"
                allow-half
                readonly
                color="#ffd21e"
                void-icon="star"
                void-color="#eee"
                size="14"
                >
                </van-rate>
                <span class="starnum">{{news.star}}</span>
            </div>
            <van-button type="default" class="down" v-if="showDown && is_gms !== 3" @click="downapk">Download</van-button>
            <van-button
                type="default"
                class="fastdown" 
                @click="highdownapk"
                v-clipboard:copy="copyPkg"
            >高速下載(<span class="tips">需下載APP</span>)</van-button>
            <div class="tips-text"><span>说明</span>:該遊戲需通過GamesToday應用進行安裝，請放心下載並安裝GamesToday！</div>
            <van-dialog
                width="80%"
                v-model="show"
                confirmButtonText="ok"
                :closeOnPopstate="over"
                :closeOnClickOverlay="over"
            >
            This game requires GMS verification before downloading,but no working GMS service is found on your phone
            </van-dialog>
          </div>
      </div>
  </div>
</template>

<script>
import { getDload, setdownpkg, getHotplay } from '@/util/hotplaygames'
import { getappinfo } from '@/util/ourplay'
import MobileDetect from 'mobile-detect'

export default {
    data() {
        return {
            news:[],
            star:1,
            is_high:1,
            show: false,
            over: true,
            url:'',
            is_gms:0,
            pkg:'',
            model:'',
            loading:true,
            showDown: false,
            scheme:'xapkdownload://xapkdownload.com/detail?pkg='
        }
    },
    computed:{
        copyPkg() {
            return `__${this.pkg}__`
        }
    },
    methods: {
        showPopup() {
            this.show = true;
        },
        async downapk() {
            try {
                location.href = this.scheme + this.pkg
            } catch (e) {
                console.log(e)
            }
            if (this.url) location.href = this.url
        },
        async highdownapk() {
                // 埋点统计
                let formdata1 = new FormData()
                formdata1.append('sign' , this.model)
                formdata1.append('pkg' , this.pkg)
                setdownpkg (formdata1);
                let formData2 = new FormData();
                formData2.append('pkg', this.pkg);
                let res = await getHotplay(formData2)
                let url = res.data.url
                this.clickDownload(url)
        },
        clickDownload (url) {
            // 唤起客户端
            window.location.href = `xapkdownload://xapkdownload.com/detail?pkg=${this.pkg}&down=1`;
            let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden 
            if(typeof hidden =="undefined" || hidden ==false){
                window.location.href = url;
            }
        },
        openApp(src) {
        // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
        // 否则打开a标签的href链接
            var ifr = document.createElement('iframe');
            ifr.src = src;
            ifr.style.display = 'none';
            document.body.appendChild(ifr);
            window.setTimeout(function(){
                document.body.removeChild(ifr);
            },2000);
        },
        async initData () {
            this.pkg = this.$route.query.apkpkg

            let res = await getappinfo({ apkpkg : this.$route.query.apkpkg })
            if (res.code == 1 && res.data && res.data.length > 0) {
                this.news = res.data[0]
                this.star = Number(this.news.star)
                this.is_high = Number(this.news.is_high_speed_download)
                this.is_gms = Number(this.news.is_gms)

                document.title = document.title.replace(/{(.*?)}/gi, `{${this.news.apkname}}`)

                let down = getDload({ pkg: this.pkg })
                this.showDown = !!(down.apklink)
                this.url = this.showDown ? down.apklink : ''
            } else {
                location.href = '/errorPage' // 若不存在则跳转错误页面
            }
        }
    },
    created() {
        this.initData()
        
        Array.prototype.contains = function(needle) {
            for (i in this) {
                if (this[i] && this[i].indexOf && this[i].indexOf(needle) > 0) {
                    return i;
                }
            }
            return -1;
        }
        var device_type = navigator.userAgent;//获取userAgent信息

        var md = new MobileDetect(device_type);//初始化mobile-detect
        var os = md.os();//获取系统
        var model = "";
        if (os == "iOS") {//ios系统的处理
            os = md.os() + md.version("iPhone");
            model = md.mobile();
        } else if (os == "AndroidOS") {//Android系统的处理
            os = md.os() + md.version("Android");
            var sss = device_type.split(";");
            var i = sss.contains("Build/");
            if (i > -1) {
                model = sss[i].substring(0, sss[i].indexOf("Build/"));
            }
            
        }
        this.model = model;
    }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 750px){
    .layout {
        .header {
            .wrapp {
                background-color: #4A90E2;
            }
        }
        .wrapp{
            background-color: #F7F7F7;
            margin-top: 0!important;
        }
    }
}
.layout {
    margin: 0 auto;
    .header {
        height: 50px;
        background-color: #4A90E2;
        padding-left: 12px;
        ol {
            li {
                float: left;
                &:first-child {
                    color: white;
                    font-size: 12px;
                    line-height: 50px;
                    opacity: .4;
                }
                &:last-child {
                    color: white;
                    font-size: 12px;
                    line-height: 50px;
                }
            }
        }
        &::after {
            display: block;
            content: '';
            clear:both;
        }
    }
    .main {
        text-align: center;
        padding: 16px;
        .van-image {
            width: 22%;
            border-radius: 2px;
        }
        .gamename {
            font-size: 18px;
            line-height: 27px;
            color: #2F3234;
            margin-top: 12px;
            margin-bottom: 8px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .developer {
            font-size: 14px;
            color: #999;
            line-height: 21px;
        }
        .line {
            font-size: 12px;
            color: #999;
        }
        .star {
            margin-top: 14px;
            .star-container {
                display: flex;
                justify-content: center;
                align-items: center;
                .starnum {
                    margin-left: 12px;
                    font-size: 13px;
                    color: #999999;
                    vertical-align: top;
                }
            }
            .down {
                width: 80%;
                background-color: #F5F5F5;
                border-radius: 6px;
                color: #4A90E2;
                margin-top: 50px;
                font-size: 12px;
            }
            .fastdown {
                display: block;
                width: 80%;
                margin:  0 auto;
                margin-top: 16px;
                color: white;
                line-height: 44px;
                font-size: 14px;
                text-align: center;
                background-color: #4A90E2;
                border-radius: 6px;
                .tips{
                    font-size: 12px;
                }
            }
            .van-dialog {
                padding-top: 16px;
                color: #333333;
                font-size: 16px;
                line-height: 24px;
                .van-button {
                    border: 1px solid rgb(216, 38, 38);
                }
            }
            .tips-text{
                margin-top: 12px;
                font-size: 14px;
                line-height: 24px;
                text-align: left;
                border: 1px solid #4A90E2;
                border-radius: 4px;
                padding: 4px 8px;
                background: #4A90E21A;
                span{
                    color: #4A90E2;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/details.vue